import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDropdownClose } from '../../hooks/useDropdownClose';
import { Sortieren } from '../../icons';
import './SortDropdown.css';

export function SortDropdown({ options, value, onChange }) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useDropdownClose(open, close);

  useEffect(() => {
    if (!open || !dropdownRef.current) return;
    const active = dropdownRef.current.querySelector('[role="option"].active');
    const first = dropdownRef.current.querySelector('[role="option"]');
    (active || first)?.focus();
  }, [open]);

  function handleOptionKeyDown(e, optKey) {
    const items = [...dropdownRef.current.querySelectorAll('[role="option"]')];
    const idx = items.indexOf(e.currentTarget);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      items[(idx + 1) % items.length]?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      items[(idx - 1 + items.length) % items.length]?.focus();
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onChange(optKey);
      setOpen(false);
      setTimeout(() => buttonRef.current?.focus(), 0);
    } else if (e.key === 'Escape') {
      setOpen(false);
      setTimeout(() => buttonRef.current?.focus(), 0);
    } else if (e.key === 'Tab') {
      setOpen(false);
    }
  }

  return (
    <div className="sort-wrapper">
      <button
        ref={buttonRef}
        className={`sort-button${open ? ' active' : ''}`}
        onClick={() => setOpen(p => !p)}
        onKeyDown={e => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            setOpen(true);
          }
        }}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label="Sortieroptionen anzeigen"
        title="Sortieroptionen anzeigen"
      >
        <span className="sort-icon" aria-hidden="true"><Sortieren /></span> Sortieren
      </button>
      {open && (
        <div className="sort-dropdown" role="listbox" ref={dropdownRef}>
          {options.map(opt => (
            <div
              key={opt.key}
              className={`sort-option${value === opt.key ? ' active' : ''}`}
              role="option"
              aria-selected={value === opt.key}
              tabIndex={0}
              onClick={() => { onChange(opt.key); setOpen(false); setTimeout(() => buttonRef.current?.focus(), 0); }}
              onKeyDown={e => handleOptionKeyDown(e, opt.key)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
